function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]:not(.removed)');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    
    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]:not(.removed)');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;
    this.dataOrientation = this.dataset.orientation || "";

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    let fully_scrolled_horizontal = this.slider.scrollLeft + this.slider.clientWidth >= this.slider.scrollWidth;

    const isFirstSlide = this.currentPage === 1;
    var isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if(this.dataOrientation == "horizontal") {
      isLastSlide = this.currentPage === this.sliderItemsToShow.length || fully_scrolled_horizontal;
    }

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    var bg_options = document.querySelector('#_bg_options');
    if(bg_options)
      this.commonbackgrounds = this.commonbackgrounds || JSON.parse(bg_options.textContent);
    var variant_bg_options = document.querySelector('#_variant_bg_options');
    if(variant_bg_options)
      this.variantbackgrounds = this.variantbackgrounds || JSON.parse(variant_bg_options.textContent);
    var variant_illustrations = document.querySelector('#_variant_illustrations');
    if(variant_illustrations)
      this.variantIllustrations = this.variantIllustrations || JSON.parse(variant_illustrations.textContent);

    var common_carousel_images = document.querySelector('#_common_carousel_images');
    if(common_carousel_images)
      this.commonCarousels = this.commonCarousels || JSON.parse(common_carousel_images.textContent);

    var carousel_images = document.querySelector('#_carousel_images');
    if(carousel_images)
      this.carousels = this.carousels || JSON.parse(carousel_images.textContent);

    var frame_swatches = document.querySelector('#_variant_frame_swatches');
    if(frame_swatches)
      this.frame_swatches = this.frame_swatches || JSON.parse(frame_swatches.textContent);

    this.bp_index = this.getAttribute('data-index');
    if(!this.bp_index)
      this.bp_index = 1;

    this.poster_type = this.getAttribute('data-type') || '';
    
    this.bp_index = parseInt(this.bp_index);

    if(this.poster_type == "custom_product") {
      document.addEventListener('frameUpdateMedia', this.frameUpdateMedia.bind(this));
    }
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    if(this.poster_type == "letterposter" || this.poster_type == "starposter") {
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantStatuses();
      this.updatePosterSize();
      this.updateFrameSwatches();
      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      }
      else {
        this.updateMedia();
        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfo();
        this.updateShareUrl();
      }
    }
    else if(this.poster_type == "photoposter") {
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantStatuses();
      this.updatePosterSize();
      this.updateFrameSwatches();
      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      }
      else if (($('.cropped-photo-input').length && $('.cropped-photo-input').val() === '') || 
      ($('.photoposter-session').length && $('.photoposter-session').val() === '')) {
        this.toggleAddButton(true, '', true);
        this.updateURL();
      } 
      else {
        this.updateMedia();
        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfo();
        this.updateShareUrl();
      }
    }
    else if(this.poster_type == "custom_product") {
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantStatuses();
  
      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfo();
        this.updateShareUrl();
      }
      this.updateCustomProductFrameSwatches();
    }
    else if(this.bp_index < 2) {
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantStatuses();
      this.updateBackgrounds();
      this.updateBackgroundSwatches();
      this.updateIllustrationSelections();
      this.updatePosterButtons();
  
      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfo();
        this.updateShareUrl();
      }
    }
    this.updateVariantIllustrations();
    this.updateIllustrationSwatches();
    if(typeof no_of_babies !== 'undefined') {
      this.updateIllustrationOptions();
    }
    if(this.commonCarousels && this.carousels) {
      this.updatePDPCarousel()
    }
  }

  updateCustomProductFrameSwatches() {
    //updateBackgroundSwatches() {
    if (!this.currentVariant || !this.frame_swatches) return;

    let form_id = $('.bp-frame-radio:checked').attr('form')

    let previous_title = $('.bp-frame-radio:checked').attr("data-title");

    let frame_block = $('.bp-frame-block').closest('.bp-sidebar-object');
    frame_block.css('opacity', 0.8);
    let frame_cont = $('.bp-frame-block');
    frame_cont.empty();

    let frame_options = this.frame_swatches[this.currentVariant.id];

    $.each(frame_options, function(index, opt) {
      var cont_div = $('<div>').addClass('bp-frame-swatch-container').attr({ id: `Slide-frame-${index+1}`});
      var div = $('<div>').addClass('bp-frame-swatch-item');
      var label = $('<label>').addClass('bp-frame-swatch').attr('for', 'frame-opt-' + index);
      
      var input = $('<input>').attr({
          type: 'radio',
          class: 'bp-frame-radio',
          name: 'frame-selector',
          id: 'frame-opt-' + index,
          checked: (index == 0) ? true : false,
          form: form_id,
          value: opt.value,
          "data-type": opt.type,
          "data-title": opt.title,
          "data-price": opt.price,
          "data-order-price": opt.order_price,
          "data-order-compare-price": opt.order_compare_price,
          "data-order-value": opt.order_value,
          "data-order-compare-value": opt.order_compare_value,
          "data-product-id": opt.product_id,
      });

      label.css('background-image', 'url(' + opt.swatch_image + ')');
      
      // Append elements to the DOM
      label.append(input);
      div.append(label);
      cont_div.append(div)
      frame_cont.append(cont_div);
    });
    frame_block[0].resetPages();

    $(`.bp-frame-radio[data-title="${previous_title}"]`).click();

    let left_scroll = ($(`.bp-frame-swatch-container:has(.bp-frame-radio:checked)`).position().left + $(`.bp-frame-block:has(.bp-frame-radio:checked)`).scrollLeft() - $(`.bp-frame-block:has(.bp-frame-radio:checked)`).width() + (2 * $(`.bp-frame-swatch-container:has(.bp-frame-radio:checked)`).width()))
    $(`.bp-frame-block:has(.bp-frame-radio:checked)`).animate({
      scrollLeft: left_scroll
    }, {
      duration: 200,  // Animation duration in milliseconds
      easing: 'linear' // Linear easing for smooth, constant speed
    });

    $('.bp-frame-radio').change(function() {
      $('.bp-frame-selected-value').text($(this).attr('data-title'));
      $('.bp-selected-frame-price').text('+ ' + $(this).attr('data-price'));

      let order_price = $(this).attr('data-order-price');
      let order_compare_price = $(this).attr('data-order-compare-price');

      if(order_price)
          $('.custom-actual-price').text(order_price);

      if(order_compare_price && (parseFloat($(this).attr('data-order-compare-value')) > parseFloat($(this).attr('data-order-value'))))
          $('.custom-compare-price').text(order_compare_price);
      else
          $('.custom-compare-price').text('');

      const frameUpdateMedia = new CustomEvent("frameUpdateMedia", { detail : { frame_id: $(this).attr('data-product-id') } });
      document.dispatchEvent(frameUpdateMedia); 
    });

    $('.bp-frame-radio:checked').change();
    setTimeout(function() { frame_block.css('opacity', 1) }, 300);
  }

  updateFrameSwatches() {
    //updateBackgroundSwatches() {
    if (!this.currentVariant || !this.frame_swatches) return;

    let form_id = $('.bp-frame-radio:checked').attr('form')

    let previous_title = $('.bp-frame-radio:checked').attr("data-title");

    let frame_block = $('.bp-frame-block').closest('.bp-sidebar-object');
    frame_block.css('opacity', 0.8);
    let frame_cont = $('.bp-frame-block');
    frame_cont.empty();

    let frame_options = this.frame_swatches[this.currentVariant.id];

    $.each(frame_options, function(index, opt) {
      var cont_div = $('<div>').addClass('bp-frame-swatch-container').attr({ id: `Slide-frame-${index+1}`});
      var div = $('<div>').addClass('bp-frame-swatch-item');
      var label = $('<label>').addClass('bp-frame-swatch').attr('for', 'frame-opt-' + index);
      
      var input = $('<input>').attr({
          type: 'radio',
          class: 'bp-frame-radio',
          name: 'frame-selector',
          id: 'frame-opt-' + index,
          checked: (index == 0) ? true : false,
          form: form_id,
          value: opt.value,
          "data-type": opt.type,
          "data-title": opt.title,
          "data-price": opt.price,
          "data-order-price": opt.order_price,
          "data-order-compare-price": opt.order_compare_price,
          "data-order-price-value": opt.order_price_value,
          "data-order-compare-price-value": opt.order_compare_price_value,
          "data-image": opt.image,
          "data-horizontal-image": opt.image_horizontal
      });

      label.css('background-image', 'url(' + opt.swatch_image + ')');
      
      // Append elements to the DOM
      label.append(input);
      div.append(label);
      cont_div.append(div)
      frame_cont.append(cont_div);
    });
    frame_block[0].resetPages();

    $(`.bp-frame-radio[data-title="${previous_title}"]`).click();

    let left_scroll = ($(`.bp-frame-swatch-container:has(.bp-frame-radio:checked)`).position().left + $(`.bp-frame-block:has(.bp-frame-radio:checked)`).scrollLeft() - $(`.bp-frame-block:has(.bp-frame-radio:checked)`).width() + (2 * $(`.bp-frame-swatch-container:has(.bp-frame-radio:checked)`).width()))
    $(`.bp-frame-block:has(.bp-frame-radio:checked)`).animate({
      scrollLeft: left_scroll
    }, {
      duration: 200,  // Animation duration in milliseconds
      easing: 'linear' // Linear easing for smooth, constant speed
    });

    $('.bp-frame-radio').change(function() {
      $('.bp-frame-selected-value').text($(this).attr('data-title'));
      $('.bp-selected-frame-price').text('+ ' + $(this).attr('data-price'));

      let order_price = $(this).attr('data-order-price');
      let order_compare_price = $(this).attr('data-order-compare-price');

      if(order_price)
          $('.bp-order-price').text(order_price);
      if(order_compare_price && (parseFloat($(this).attr('data-order-compare-price-value')) > parseFloat($(this).attr('data-order-price-value'))))
          $('.bp-order-compare-price').text(order_compare_price);
      else
          $('.bp-order-compare-price').text('');
      
      if($('.birthposter-template').hasClass('horizontal-poster') || $('.birthposter-template').hasClass('bp_landscape'))
          $('.bp-poster-frame').css('background-image', `url(${$(this).attr('data-horizontal-image')})`);
      else
          $('.bp-poster-frame').css('background-image', `url(${$(this).attr('data-image')})`);

      if($(this).attr("data-type") == "frame") {
          $('.bp-poster-frame').css('box-shadow', `0 0 20px -5px #adadad`);
          $('.bp-poster-preview').css('box-shadow', `none`);
      }
      else {
          $('.bp-poster-frame').css('box-shadow', `none`);
          $('.bp-poster-preview').css('box-shadow', `0 0 20px -5px #adadad`);
      }
    });

    $('.bp-frame-radio').on('change input', function(){
      localStorage.setItem($(this).attr('name'), $(this).val());
    });

    $('.bp-frame-radio:checked').change();
    setTimeout(function() { frame_block.css('opacity', 1) }, 300);
  }

  getSizeClasses(index, classNames) {
    var current_classes = classNames.split(" "), classes_to_remove = []; 
    
    $.each(current_classes, function (index, class_name) {
      if (/^_.*/.test(class_name)) {classes_to_remove.push(class_name);}
    });

    return classes_to_remove.join(" ");
  }

  updatePosterSize() {
    if (!this.currentVariant) return;
    
    $('.birthposter-template').removeClass(this.getSizeClasses);
    $('.hidden-preview').removeClass(this.getSizeClasses);

    $('.birthposter-template').addClass(`_${this.currentVariant.title}`);
    $('.hidden-preview').addClass(`_${this.currentVariant.title}`);

    $('.bp-poster-bottom-headline').text(`${this.currentVariant.title} CM`);
    if(this.poster_type == "photoposter") {
      let curr_size = $('#current-size');
      if(curr_size.length) {
        curr_size.val(this.currentVariant.title)
      }
    }
  }

  updatePDPCarouselitems() {
    if(this.carouselNeedsUpdate == false || this.carouselNeedsUpdate == undefined) return;
    $('.pdp-carousel').empty();
    $('.pdp_carousel_footer').css('display', 'none');
    $('.pdp-carousel').removeClass('slick-initialized').removeClass('slick-slider')

    for(var i = 0; i < this.carousels[this.currentVariant.id].length; i++) {
      let item = this.carousels[this.currentVariant.id][i];
      let div = $('<div>').addClass('pdp-carousel-item-cont');
      let child_div = $('<div>').addClass('pdp-carousel-item');
      let img = $('<img>').attr('width', "100%").attr('height', "auto").attr('data-lazy', item.image)

      child_div.append(img)
        // .append(item.title)
      div.append(child_div)
      $('.pdp-carousel').append(div)
    }
    for(var i = 0; i < this.commonCarousels.length; i++) {
      let item = this.commonCarousels[i];
      let div = $('<div>').addClass('pdp-carousel-item-cont');
      let child_div = $('<div>').addClass('pdp-carousel-item');
      let img = $('<img>').attr('width', "100%").attr('height', "auto").attr('data-lazy', item.image)

      child_div.append(img)
        // .append(item.title)
      div.append(child_div)
      $('.pdp-carousel').append(div)
    }

    let total_length = this.commonCarousels.length + this.carousels[this.currentVariant.id].length;
    if (total_length != 0) {
      let subtitle_object = this.currentVariant.title;
      if (typeof no_of_babies !== 'undefined') {
        if(no_of_babies == 2)
          subtitle_object = 'DUO'
        else if (no_of_babies == 3)
          subtitle_object = 'TRIO'
        else if (no_of_babies == 4)
          subtitle_object = 'QUATTRO'
      }
      $('.pdp_carousel_footer strong').html(subtitle_object);
      $('.pdp_carousel_footer').css('display', 'block');
      $('.pdp-carousel').slick({
        infinite: true,
        slidesToShow: 6,
        prevArrow: $('.pdp-carousel-button[name="previous"]'),
        nextArrow: $('.pdp-carousel-button[name="next"]'),
        lazyLoad: 'ondemand',
        responsive: [
          {
          breakpoint: 2000,
          settings: {
              slidesToShow: 4,
              slidesToScroll: 2
          }
          },
          {
          breakpoint: 1700,
          settings: {
              slidesToShow: 3,
              slidesToScroll: 2
          }
          },
          {
          breakpoint: 1000,
          settings: {
              slidesToShow: 2,
              slidesToScroll: 2
          }
          },
          {
          breakpoint: 600,
          settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: true,
              centerPadding: '30px',
          }
          }
        ]
      });
    }
  }

  updatePDPCarousel() {
    if (!this.currentVariant) return;

    let total_length = this.commonCarousels.length + this.carousels[this.currentVariant.id].length;
    if (total_length == 0) {
      $('.pdp-carousel-block').css("max-height", "0px");
      setTimeout(() => {
        this.updatePDPCarouselitems();
      }, 400);
    } 
    else {
      this.updatePDPCarouselitems();
      $('.pdp-carousel-block').css("max-height", "850px");
    }
  }

  updateIllustrationOptions () {
    if (!this.currentVariant) return;

    let elem = $(`#bp-illustration-${this.bp_index}`);

    elem.val(this.currentVariant.title.toLowerCase().replaceAll(" ", "-").replaceAll("#", ""));
    localStorage.setItem(elem.attr('name'), elem.val());
  }

  updatePosterButtons() {
    if (!this.currentVariant) return;

    let index = this.getVariantData().findIndex(obj => obj.id === this.currentVariant.id);
    let last_index = this.getVariantData().length;

    $('.bp-poster-left').attr("disabled", false);
    $('.bp-poster-right').attr("disabled", false);

    if(index == 0) {
      $('.bp-poster-left').attr("disabled", true);
    }
    else if (index == (last_index - 1)) {
      $('.bp-poster-right').attr("disabled", true);
    }
  }

  updateBackgrounds() {
    if(this.commonbackgrounds && this.currentVariant) {
      let var_bg = this.variantbackgrounds[this.currentVariant.id]
      this.currentVariant['background_type'] = (var_bg) ? var_bg.bg_type : 'color';
      this.currentVariant['backgrounds'] = (var_bg.hasOwnProperty('options')) ? var_bg.options : this.commonbackgrounds;
      this.currentVariant['additional_backgrounds'] = (var_bg.hasOwnProperty('additional_bg_options')) ? var_bg.additional_bg_options : ''
    }
  }

  updateBackgroundSwatches() {
    if (!this.currentVariant || !this.currentVariant.hasOwnProperty('backgrounds')) return;

    let form_id = $('.bp-background-radio:checked').attr('form');
    let element_name = $(`.bp-background-radio:checked`).attr('name');

    let previous_value = $('.bp-background-radio:checked').val();

    let bg_block = $('.bp-bg-block').closest('.bp-sidebar-object');
    bg_block.css('opacity', 0.8);
    let bg_cont = $('.bp-bg-block');
    bg_cont.empty();

    let bg_options = this.currentVariant['backgrounds']
    if(this.currentVariant['additional_backgrounds']){
      bg_options = bg_options.concat(this.currentVariant['additional_backgrounds'])  
    }
    let bg_type = this.currentVariant['background_type']

    $.each(bg_options, function(index, opt) {
      var cont_div = $('<div>').addClass('bp-swatch-container').attr({ id: `Slide-bg-${index+1}`});
      var div = $('<div>').addClass('bp-background-swatch-item');
      var label = $('<label>').addClass('bp-background-swatch').attr('for', 'bg-opt-' + index);
      
      var input = $('<input>').attr({
          type: 'radio',
          class: 'bp-background-radio',
          name: element_name,
          id: 'bg-opt-' + index,
          value: opt.english_name.toLowerCase().replace(" ", ""),
          "data-name": (bg_type == 'image') ? opt.color_name : opt.name,
          checked: (index == 0) ? true : false,
          form: form_id,
          ...((bg_type == 'image') ? { "data-image": `${ opt.background_image }`} : {"data-color": `${ opt.color }` })
      });

      // Set background image or color based on the option type
      if (bg_type == 'image') {
        label.css('background-image', 'url(' + opt.swatch + ')');
      } else {
        label.css('background-color', opt.color);
      }
      
      // Append elements to the DOM
      label.append(input);
      div.append(label);
      cont_div.append(div)
      bg_cont.append(cont_div);
    });
    bg_block[0].resetPages();

    $(`.bp-background-radio[value="${previous_value}"]`).click();
    let left_scroll = ($(`.bp-swatch-container:has(.bp-background-radio:checked)`).position().left + $(`.bp-bg-block:has(.bp-background-radio:checked)`).scrollLeft() - $(`.bp-bg-block:has(.bp-background-radio:checked)`).width() + (2 * $(`.bp-swatch-container:has(.bp-background-radio:checked)`).width()))
    $(`.bp-bg-block:has(.bp-background-radio:checked)`).animate({
      scrollLeft: left_scroll
    }, {
      duration: 200,  // Animation duration in milliseconds
      easing: 'linear' // Linear easing for smooth, constant speed
    });

    if(bg_type == 'image'){
      $('.bp-bg-title').text('BACKGROUND IMAGE');
      $('.bp-preview-illustration').css('background-color', `transparent`);
      $('.bp-preview-illustration').css('background-image', `url(${$('.bp-background-radio:checked').attr('data-image')})`);
      $('.bp-background-radio').change(function() {
        $('.bp-bg-selected-value').text($(this).attr("data-name"));
        $('.bp-preview-illustration').css('background-image', `url(${$(this).attr('data-image')})`)      
    });
    }
    else if (bg_type == 'color') {
      $('.bp-bg-title').text('BAKGRUNDSFÄRG');
      $('.bp-preview-illustration').css('background-image', `none`);
      $('.bp-preview-illustration').css('background-color', `${$('.bp-background-radio:checked').attr('data-color')}`);
      $('.bp-background-radio').change(function() {
        $('.bp-bg-selected-value').text($(this).attr("data-name"))     
        $('.bp-preview-illustration').css('background-color', `${$(this).attr('data-color')}`);
        let selected_bg = $(this).val();
        let available_colors = colorOptions[selected_bg];
        if(available_colors) {
            let color_list = available_colors.color_list;
            $(".bp-illustration-radio").each((_, item) => {
                let color = $(item).val();
                let swatch_cont = $(item).closest(".bp-swatch-container");
                swatch_cont.removeClass('removed');
                if(!color_list.includes(color)) {
                    swatch_cont.addClass('removed');
                }
            })
            if(!localStorageProcessing) {
                for (var i = 1; i <= no_of_babies; i++) {
                    let default_swatch = $(`.bp-illustration-radio[data-index="${i}"][value="${available_colors.default}"]`);
                    if(default_swatch.length > 0) {
                        default_swatch.click();
                    }
                    else {
                        $(`.bp-swatch-container:not(.removed) .bp-illustration-radio[data-index="${i}"]`).first().click();
                    }
                }
            }
            $(".bp-illustration-block").each((_, item) => {
                let index = $(item).attr('data-index');
                let slider = $(item).closest('slider-component');
                if(slider.length > 0) {
                    slider[0].resetPages();
                    let left_scroll = ($(`.bp-swatch-container:has(.bp-illustration-radio[data-index="${index}"]:checked)`).position().left + $(`.bp-illustration-block:has(.bp-illustration-radio[data-index="${index}"]:checked)`).scrollLeft() - $(`.bp-illustration-block:has(.bp-illustration-radio[data-index="${index}"]:checked)`).width() + (2 * $(`.bp-swatch-container:has(.bp-illustration-radio[data-index="${index}"]:checked)`).width()))
                    $(`.bp-illustration-block:has(.bp-illustration-radio[data-index="${index}"]:checked)`).animate({
                        scrollLeft: left_scroll
                    }, {
                        duration: 200,  // Animation duration in milliseconds
                        easing: 'linear' // Linear easing for smooth, constant speed
                    });
                }
            })
        } 
    });
    }

    $('.bp-background-radio').on('change input', function(){
      localStorage.setItem($(this).attr('name'), $(this).val());
    });

    setTimeout(function() { bg_block.css('opacity', 1) }, 300);
    $('.bp-bg-selected-value').text($('.bp-background-radio:checked').attr("data-name"));
    localStorage.setItem($('.bp-background-radio').attr('name'), $('.bp-background-radio:checked').val());
  }

  updateIllustrationSelections() {
    if (!this.currentVariant) return;

    let selected_illustration = $('.bp-variant-options-radio[data-index="1"]:checked').attr("data-value");
    let illustrations_object = illustrationOptions[selected_illustration];
    if(illustrations_object) {
      let illustration_list = illustrations_object.available_illustrations;
      for (var i = 2; i <= no_of_babies; i++) {
          $(`.bp-variant-options-radio[data-index="${i}"]`).each((_, item) => {
              let illustration = $(item).attr("data-value");
              let id = $(item).prop("id");
              let swatch_cont = $(`.bp-variant-label[for="${id}"]`);
              swatch_cont.removeClass('removed');
              if(!illustration_list.includes(illustration)) {
                  swatch_cont.addClass('removed');
              }
          });
          if (!localStorageProcessing) {
              let local_storage_item = localStorage.getItem(`properties[__illustration_${i}]`);
              if (!illustration_list.includes(local_storage_item)) {
                let default_swatch = $(`.bp-variant-options-radio[data-index="${i}"][data-value="${illustrations_object.default[i - 2]}"]`);
                if(default_swatch.length > 0) {
                    default_swatch.click();
                }
                else {
                    $(`.bp-variant-options-radio[data-index="${i}"] + label:not(.removed)`).first().click();
                }
                localStorage.removeItem(`properties[__illustration_${i}]`)
              }
          }
      }
    }
  }

  updateVariantIllustrations() {
    if (!this.currentVariant || !this.variantIllustrations) return;
    this.currentVariant['illustrations'] = this.variantIllustrations[this.currentVariant.id]
  }

  async updateIllustrationSwatches() {
    if (!this.currentVariant || !this.currentVariant.hasOwnProperty('illustrations') ) return;
    let form_id = $(`.bp-illustration-radio[data-index="${this.bp_index}"]:checked`).attr('form')
    let element_name = $(`.bp-illustration-radio[data-index="${this.bp_index}"]:checked`).attr('name');

    let previous_value = $(`.bp-illustration-radio[data-index="${this.bp_index}"]:checked`).val();

    let illustration_block = $(`.bp-illustration-block[data-index="${this.bp_index}"]`).closest('.bp-sidebar-object');
    illustration_block.css('opacity', 0.8);
    $(`.bp-preview-illustration img[data-index="${this.bp_index}"]`).css('visibility', 'hidden');
    $(`.bp-preview-illustration img[data-index="${this.bp_index}"]`).css('opacity', 0.8);

    if(this.currentVariant.title.includes('Aquarelle')) {
      $(`.bp-preview-illustration img[data-index="${this.bp_index}"]`).css('mix-blend-mode', 'multiply');
    }
    else {
      $(`.bp-preview-illustration img[data-index="${this.bp_index}"]`).css('mix-blend-mode', 'unset');
    }

    let illustration_cont = $(`.bp-illustration-block[data-index="${this.bp_index}"]`);
    illustration_cont.empty();

    let illustrations = this.currentVariant['illustrations'];

    if(illustrations.length < 2) {
      $(`.bp-illustration-img[data-index="${this.bp_index}`).addClass('auto-contrast');
      $(".bp-signature").addClass('auto-contrast');
    }
    else {
      $(`.bp-illustration-img[data-index="${this.bp_index}`).removeClass('auto-contrast');
      $(".bp-signature").removeClass('auto-contrast');
    }

    $.each(illustrations, (index, illustration) => {
      var cont_div = $('<div>').addClass('bp-swatch-container').attr({id: `Slide-illustration-${this.bp_index}-${index + 1}`});
      var div = $('<div>').addClass('bp-illustration-swatch-item');
      var label = $('<label>').addClass('bp-illustration-swatch').attr('for', `illustration-opt-${index}-${this.bp_index}`);
      
      var input = $('<input>').attr({
          type: 'radio',
          class: 'bp-illustration-radio',
          name: element_name,
          id: `illustration-opt-${index}-${this.bp_index}`,
          "data-index": this.bp_index,
          value: illustration.english_color_name.toLowerCase().replace(" ", ""),
          "data-name": illustration.color_name,
          checked: (index == 0) ? true : false,
          form: form_id,
         "data-image": `${ illustration.image }`, 
         "data-color": `${ illustration.color }`
      });

      // Set background image or color based on the option type
      if (illustration.hasOwnProperty('swatch')) {
        label.css('background-image', 'url(' + illustration.swatch + ')');
      } else {
        label.css('background-color', illustration.color);
      }
      
      // Append elements to the DOM
      label.append(input);
      div.append(label);
      cont_div.append(div);
      illustration_cont.append(cont_div);
    });
    illustration_block[0].resetPages();

    let selected_bg = $('.bp-background-radio:checked').val();
    let available_colors = colorOptions[selected_bg];
    if(available_colors) {
      let color_list = available_colors.color_list;
      $(".bp-illustration-radio").each((_, item) => {
          let color = $(item).val();
          let swatch_cont = $(item).closest(".bp-swatch-container");
          swatch_cont.removeClass('removed');
          if(!color_list.includes(color)) {
              swatch_cont.addClass('removed');
          }
      });
      if(!localStorageProcessing) {
        let previously_selected_color = $(`.bp-illustration-radio[data-index="${this.bp_index}"][value="${previous_value}"]`);
        if(previously_selected_color.length > 0 && color_list.includes(previous_value)) {
          $(`.bp-illustration-radio[data-index="${this.bp_index}"][value="${previous_value}"]`).click();
          let left_scroll = ($(`.bp-swatch-container:has(.bp-illustration-radio[data-index="${this.bp_index}"]:checked)`).position().left + $(`.bp-illustration-block:has(.bp-illustration-radio[data-index="${this.bp_index}"]:checked)`).scrollLeft() - $(`.bp-illustration-block:has(.bp-illustration-radio[data-index="${this.bp_index}"]:checked)`).width() + (2 * $(`.bp-swatch-container:has(.bp-illustration-radio[data-index="${this.bp_index}"]:checked)`).width()))
          $(`.bp-illustration-block:has(.bp-illustration-radio[data-index="${this.bp_index}"]:checked)`).animate({
            scrollLeft: left_scroll
          }, {
            duration: 200,  // Animation duration in milliseconds
            easing: 'linear' // Linear easing for smooth, constant speed
          });
        }
        else {
          let default_swatch = $(`.bp-illustration-radio[data-index="${this.bp_index}"][value="${available_colors.default}"]`);
          if(default_swatch.length > 0) {
              default_swatch.click();
          }
          else {
              $(`.bp-swatch-container:not(.removed) .bp-illustration-radio[data-index="${this.bp_index}"]`).first().click();
          }
        }
      }
      else {
        $(`.bp-illustration-radio[data-index="${this.bp_index}"][value="${previous_value}"]`).click();
        let left_scroll = ($(`.bp-swatch-container:has(.bp-illustration-radio[data-index="${this.bp_index}"]:checked)`).position().left + $(`.bp-illustration-block:has(.bp-illustration-radio[data-index="${this.bp_index}"]:checked)`).scrollLeft() - $(`.bp-illustration-block:has(.bp-illustration-radio[data-index="${this.bp_index}"]:checked)`).width() + (2 * $(`.bp-swatch-container:has(.bp-illustration-radio[data-index="${this.bp_index}"]:checked)`).width()))
        $(`.bp-illustration-block:has(.bp-illustration-radio[data-index="${this.bp_index}"]:checked)`).animate({
          scrollLeft: left_scroll
        }, {
          duration: 200,  // Animation duration in milliseconds
          easing: 'linear' // Linear easing for smooth, constant speed
        });
      }
    }

    //changing to blank image becuause otherwise changing from vertical to horizontal or vice versa causes image glitch as they have different size rules.
    let blank_image_src = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
    $(`.bp-preview-illustration img[data-index="${this.bp_index}"]`).attr("src", blank_image_src);
    if(this.layoutchanged)
    $('.bp-poster-frame').css('background-image', `url(${blank_image_src})`);
    //this empty timeout is needed as otherwise img does not acknowledge blank src img
    await new Promise(resolve => setTimeout(resolve, 10));

    if(this.currentVariant.title.includes('Horizontal')) {
      $('.birthposter-template').addClass('horizontal-poster');
      $('.hidden-preview').addClass('horizontal-poster');
      if($('.bp-frame-radio:checked').attr('data-type') == 'posterhanger'){
        $('.bp-frame-radio[value="no_frame"]').click();
      }
    }
    else {
      $('.birthposter-template').removeClass('horizontal-poster');
      $('.hidden-preview').removeClass('horizontal-poster');
    }


    $(`.bp-birth-length-selector[data-index="${this.bp_index}"]`).change();

    if(this.bp_index > 1){
      $(`.bp-illustration-block[data-index="${this.bp_index}"]`).closest('.bp-sidebar-object').addClass('hide')
    }
    else {
      if(this.currentVariant.illustrations.length < 2) {
        $(`.bp-illustration-block[data-index="${this.bp_index}"]`).closest('.bp-sidebar-object').addClass('hide')
      }
      else {
        $(`.bp-illustration-block[data-index="${this.bp_index}"]`).closest('.bp-sidebar-object').removeClass('hide')
      }
    }

    if ($(`.bp-illustration-radio[data-index="${this.bp_index}"]`).length) {
      $(`.bp-illustration-radio[data-index="${this.bp_index}"]`).change(function() {
        let index = $(this).attr('data-index');
        let val = $(this).val();
        $(`.bp-illustration-selected-value[data-index="${index}"]`).text($(this).attr("data-name"));
        $(`.bp-preview-illustration img[data-index="${index}"]`).attr('src', `${$(this).attr('data-image')}`);
        $(`.bp-signature`).css("--signature-color", `${$(this).attr('data-color')}`); 
        for(var i=1; i <= no_of_babies; i++) {
          $(`.bp-illustration-radio[data-index="${i}"][value="${val}"]`).click();
        } 
      });

      $(`.bp-illustration-radio[data-index="${this.bp_index}"]`).on('change input', function(){
        localStorage.setItem($(this).attr('name'), $(this).val());
      });

      $(`.bp-illustration-selected-value[data-index="${this.bp_index}"]`).text($(`.bp-illustration-radio[data-index="${this.bp_index}"]:checked`).attr("data-name"));
      $(`.bp-signature`).css("--signature-color", `${$(`.bp-illustration-radio[data-index="${this.bp_index}"]:checked`).attr('data-color')}`);  
      localStorage.setItem($(`.bp-illustration-radio[data-index="${this.bp_index}"]`).attr('name'), $(`.bp-illustration-radio[data-index="${this.bp_index}"]:checked`).val());
      let val = $(`.bp-illustration-radio[data-index="${this.bp_index}"]:checked`).val();
      for(var i=1; i <= no_of_babies; i++) {
        $(`.bp-illustration-radio[data-index="${i}"][value="${val}"]`).click();
      }
      $(`.bp-preview-illustration img[data-index="${this.bp_index}"]`).attr("src", `${$(`.bp-illustration-radio[data-index="${this.bp_index}"]:checked`).attr('data-image')}`)
    }
  
    setTimeout(function() { illustration_block.css('opacity', 1) }, 300);
    setTimeout(() => { 
      if(this.layoutchanged)
      $('.bp-frame-radio:checked').trigger("change");
      $(`.bp-preview-illustration img[data-index="${this.bp_index}"]`).css('visibility', 'visible');
      setTimeout(() => {
        $(`.bp-preview-illustration img[data-index="${this.bp_index}"]`).css('opacity', 1);
      }, 100); 
    }, 250);
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.layoutchanged = false;
    let previous_title = '';

    this.carouselNeedsUpdate = false;
    let previous_variant_carousel = parseInt($('#carousel_length').val()) || 0;

    if(this.currentVariant && (typeof this.currentVariant !== "undefined")) {
      previous_title = this.currentVariant.title;
    }
    if(this.carousels && this.currentVariant && (typeof this.currentVariant !== "undefined")) {
      previous_variant_carousel = this.carousels[this.currentVariant.id].length;
    }
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
    let current_title = this.currentVariant.title;
    if((previous_title.includes("Horizontal") && !current_title.includes("Horizontal")) || (!previous_title.includes("Horizontal") && current_title.includes("Horizontal"))){
      this.layoutchanged = true;
    }
    if(this.carousels && (previous_variant_carousel != 0 || this.carousels[this.currentVariant.id].length != 0 )) {
      this.carouselNeedsUpdate = true;
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  frameUpdateMedia(event) {
    const frame_id = event.detail.frame_id;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) => {
      let gallery_item = mediaGallery.querySelector(`[data-custom-selector="${frame_id}"]`);
      if(gallery_item) {
        mediaGallery.setActiveMedia(gallery_item.getAttribute('data-media-id'), true);
      }
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    let url = `${this.dataset.url}?variant=${this.currentVariant.id}`;
    if(typeof edit_item !== 'undefined' && edit_item === true) {
      url = url + `&item_key=${item_key}`;
    }
    window.history.replaceState({}, '', url);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
        
        if(this.poster_type == "custom_product" && this.frame_swatches) {
          $('.bp-frame-radio:checked').change();
        }
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      if((typeof edit_cart !== 'undefined' && edit_cart === true)) {
        addButtonText.textContent = window.variantStrings.editPoster;
      }
      else if((typeof edit_item !== 'undefined' && edit_item === true)) {
        if((typeof changes_made !== 'undefined' && changes_made === false)) {
          addButton.setAttribute('aria-disabled', true);
          addButtonText.textContent = window.variantStrings.changesSaved;
        }
        else {
          addButton.removeAttribute('aria-disabled');
          addButtonText.textContent = window.variantStrings.saveChanges;
        }
      }
      else {
        addButtonText.textContent = window.variantStrings.addToCart;
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class VariantCustom extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        if(input.tagName == 'OPTION')
          input.innerText = input.getAttribute('value');
        else
          input.classList.remove('disabled');
      } else {
        if(input.tagName == 'OPTION')
          input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
        else
          input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    let options_array = Array.from(this.querySelectorAll('select,fieldset'),
      (element) => {
        if (element.tagName === 'SELECT') {
          return element.value;
        } 
        else {
          const checkedRadio = Array.from(element.querySelectorAll('input[type="radio"]'))
            .find((radio) => radio.checked);
          return checkedRadio ? checkedRadio.value : null;
        }
      }
    ); 

    this.options = options_array;
  }
}

customElements.define('variant-custom', VariantCustom);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);
